/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import React, { useState, useRef, useEffect } from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import ModalizeBase from '@web-components/modals/ModalizeBase';
// import { WithLocalSvg }  from 'react-native-svg';
import Radio from '@web-components/form/Radio';
import { formGroup, formWrapper } from '~assets/styles/formStyles';
const Button = React.lazy(() => import('@web-components/form/Button'));
import { reportReview } from '~store/product-detail/thunks';
import { unwrapResult } from '@reduxjs/toolkit';
import Toast from 'react-native-toast-message';

const ModalReviewReport = (props) => {
  const dispatch = useDispatch();
  const isShow = useSelector((state) => state.modal.reportReview.isShow);
  const data = useSelector((state) => state.modal.reportReview.data);
  const statusApiReportReview = useSelector(
    (state) => state.productDetail.status.productDetail,
  );
  const [isDisabled, setIsDisabled] = useState(true);
  const modalizeRef = useRef(null);
  const [dataRadio, setDataRadio] = useState([
    {
      name: 'SPAM',
      isChecked: false,
      key: 0,
    },
    {
      name: 'Inappropiate',
      isChecked: false,
      key: 1,
    },
    {
      name: 'Offensive',
      isChecked: false,
      key: 2,
    },
  ]);

  const closeModal = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'reportReview' });
  };

  const clearState = () => {
    setDataRadio([
      {
        name: 'SPAM',
        isChecked: false,
        key: 0,
      },
      {
        name: 'Inappropiate',
        isChecked: false,
        key: 1,
      },
      {
        name: 'Offensive',
        isChecked: false,
        key: 2,
      },
    ]);
    dispatch({
      type: 'productDetail/setStatusApi',
      name: 'reportReview',
      value: 'idle',
    });
  };

  const submitHandler = async () => {
    const item = dataRadio.find((item) => item.isChecked);
    const id = data.newsfeed_id;
    const payload = {
      content: '',
      newsfeed_id: data.newsfeed_id,
      type: item.name.toLocaleLowerCase(),
    };

    try {
      const resultAction = await dispatch(reportReview({ id, payload }));
      // eslint-disable-next-line no-unused-vars
      const response = unwrapResult(resultAction);
      Toast.show({ text1: 'Laporan anda berhasil terkirim' });
      closeModal();
    } catch (err) {
      closeModal();
    }
  };

  const selectedRadioHandler = (index) => {
    const copyDataRadio = [...dataRadio];
    copyDataRadio.map((item, indexItem) => {
      if (index === indexItem) {
        copyDataRadio[indexItem].isChecked = true;
      } else {
        copyDataRadio[indexItem].isChecked = false;
      }
    });
    setDataRadio(copyDataRadio);
  };

  useEffect(() => {
    const alreadyChecked = dataRadio.find((item) => item.isChecked);
    if (alreadyChecked) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [dataRadio]);

  useEffect(() => {
    if (isShow) {
      modalizeRef.current?.open();
    } else {
      clearState();
      modalizeRef.current?.close();
    }
  }, [isShow]);

  return (
    <ModalizeBase
      withInsetsBottom={true}
      adjustToContentHeight={true}
      ref={modalizeRef}
      onClosed={closeModal}>
      <View style={styles.modalContainer}>
        <View style={styles.modalHeader}>
          <Text style={styles.modalHeaderHeading}>Report</Text>
          <Pressable style={styles.modalDismiss} onPress={closeModal}>
            {/* <WithLocalSvg
              key="dismiss"
              width={14}
              height={14}
              asset={require('~assets/img/common/modal-dismiss.svg')}
              onPress={closeModal}
            />*/}
          </Pressable>
        </View>

        <View style={styles.modalBody}>
          <Text style={styles.textReport}>
            Pilih alasan kenapa Anda ingin melaporkan konten ini:
          </Text>

          <View>
            {dataRadio.map((item, index) => (
              <View style={[formWrapper, { marginBottom: 20 }]} key={index}>
                <View style={formGroup}>
                  <Radio
                    title={item.name}
                    checked={item.isChecked}
                    onPress={() => {
                      selectedRadioHandler(index);
                    }}
                  />
                </View>
              </View>
            ))}
          </View>

          <View>
            <Button
              title="Submit"
              onPress={submitHandler}
              disabled={isDisabled || statusApiReportReview === 'loading'}
            />
          </View>
        </View>
      </View>
    </ModalizeBase>
  );
};

const styles = StyleSheet.create({
  modalBody: {},
  modalContainer: {
    paddingHorizontal: 16,
    paddingBottom: 24,
    paddingTop: 20,
    minHeight: 276,
  },
  modalDismiss: {
    position: 'absolute',
    right: 4,
    top: 3,
  },
  modalHeader: {
    position: 'relative',
    marginBottom: 16,
  },
  modalHeaderHeading: {
    fontFamily: 'satoshi-black',
    fontSize: 17,
    lineHeight: 23,
    color: '#25182E',
  },
  textReport: {
    fontFamily: 'satoshi-medium',
    fontSize: 13,
    lineHeight: 23,
    color: '#25182E',
    marginBottom: 16,
  },
});

export default ModalReviewReport;
